// extracted by mini-css-extract-plugin
export default {"component":"BigPurpuleButtonStyles_component__VUVpZ","text":"BigPurpuleButtonStyles_text__+vkpd"};